import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
export default function PolicyDetails({ policy, loading, onQuickTest, onCustomTest }) {
    const [showFullConfig, setShowFullConfig] = useState(false);
    return /*#__PURE__*/ _jsxs("div", {
        className: "border border-border rounded-lg p-4 bg-card",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "text-xl font-semibold mb-4 text-card-foreground",
                children: "Policy Details"
            }),
            loading ? /*#__PURE__*/ _jsxs("div", {
                className: "text-center py-8 text-muted-foreground",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"
                    }),
                    "Loading policy details..."
                ]
            }) : policy ? /*#__PURE__*/ _jsxs("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: "font-semibold text-card-foreground mb-2",
                                children: "Basic Information"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "bg-muted rounded-md p-3",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "grid grid-cols-2 gap-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "font-medium text-card-foreground",
                                                        children: "Name:"
                                                    }),
                                                    ' ',
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-muted-foreground",
                                                        children: policy.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "font-medium text-card-foreground",
                                                        children: "Version:"
                                                    }),
                                                    ' ',
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-muted-foreground",
                                                        children: policy.version
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "font-medium text-card-foreground",
                                                        children: "Kind:"
                                                    }),
                                                    ' ',
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-muted-foreground",
                                                        children: policy.kind
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "font-medium text-card-foreground",
                                                        children: "Updated:"
                                                    }),
                                                    ' ',
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-muted-foreground",
                                                        children: new Date(policy.updated_at).toLocaleDateString()
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    policy.description && /*#__PURE__*/ _jsxs("div", {
                                        className: "mt-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "font-medium text-card-foreground",
                                                children: "Description:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-muted-foreground",
                                                children: policy.description
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-between mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "font-semibold text-card-foreground",
                                        children: "Policy Configuration"
                                    }),
                                    /*#__PURE__*/ _jsx("button", {
                                        type: "button",
                                        onClick: ()=>setShowFullConfig(!showFullConfig),
                                        className: "text-sm px-2 py-1 bg-muted text-muted-foreground rounded hover:bg-muted/80 transition-colors",
                                        children: showFullConfig ? 'Collapse' : 'Expand'
                                    })
                                ]
                            }),
                            showFullConfig && /*#__PURE__*/ _jsx("div", {
                                className: "bg-muted rounded-md p-3 max-h-96 overflow-y-auto",
                                children: /*#__PURE__*/ _jsx("pre", {
                                    className: "text-xs font-mono text-card-foreground whitespace-pre-wrap break-words",
                                    children: JSON.stringify(policy, null, 2)
                                })
                            }),
                            !showFullConfig && /*#__PURE__*/ _jsx("div", {
                                className: "bg-muted rounded-md p-3 text-sm text-muted-foreground",
                                children: /*#__PURE__*/ _jsx("p", {
                                    children: 'Click "Expand" to view full policy configuration'
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex space-x-3",
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                onClick: ()=>onQuickTest(policy.name),
                                className: "px-4 py-2 bg-accent text-accent-foreground rounded-md hover:bg-accent/90 transition-colors",
                                children: "Quick Test"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                onClick: onCustomTest,
                                className: "px-4 py-2 bg-secondary text-secondary-foreground rounded-md hover:bg-secondary/90 transition-colors",
                                children: "Custom Test"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ _jsx("div", {
                className: "text-center py-8 text-muted-foreground",
                children: "Select a policy from the list to view details"
            })
        ]
    });
}
